import { AllieText } from "../../../../../components";
import { AllieDateField } from "../../../DateField";

interface DueDateProps {
  overdue: boolean;
  value: number;
  labelOverDue: string;
}

export const DueDate: React.FC<DueDateProps> = ({ overdue, value, labelOverDue }) => (
  <>
    <AllieText type='body1' color={overdue ? 'error-main' : 'neutral-80'}>
      <AllieDateField timestamp={value} format="DD-MM-YYYY HH:mm" />
    </AllieText>
    {overdue && <AllieText type='field2' color='error-main'>{labelOverDue}</AllieText>}
  </>
);